import { render, staticRenderFns } from "./ReactionIconTotal.vue?vue&type=template&id=433b3351&scoped=true&"
import script from "./ReactionIconTotal.vue?vue&type=script&lang=js&"
export * from "./ReactionIconTotal.vue?vue&type=script&lang=js&"
import style0 from "./ReactionIconTotal.vue?vue&type=style&index=0&id=433b3351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433b3351",
  null
  
)

export default component.exports